import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "event-timeline",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "Follow protection activity across the event timeline.",
    domain: "events",
    visual: "Timeline",
    purposes: ["live"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "timeline", skeleton: "timeline" },
  defaultLayoutClassName: "col-span-12",
};
